"use strict";
// Copyright (C) Microsoft Corporation. All rights reserved.
Object.defineProperty(exports, "__esModule", { value: true });
exports.KeyboardAction = exports.KeyboardKey = void 0;
var KeyboardKey;
(function (KeyboardKey) {
    KeyboardKey["Enter"] = "Enter";
    KeyboardKey["Escape"] = "Escape";
    KeyboardKey["TVRemoteBack"] = "XF86Back";
    KeyboardKey["ArrowUp"] = "ArrowUp";
    KeyboardKey["ArrowDown"] = "ArrowDown";
    KeyboardKey["ArrowLeft"] = "ArrowLeft";
    KeyboardKey["ArrowRight"] = "ArrowRight";
    KeyboardKey["Tab"] = "Tab";
})(KeyboardKey || (exports.KeyboardKey = KeyboardKey = {}));
var KeyboardAction;
(function (KeyboardAction) {
    KeyboardAction["Down"] = "keyboardDown";
    KeyboardAction["Up"] = "keyboardUp";
    KeyboardAction["Repeat"] = "keyboardRepeat";
})(KeyboardAction || (exports.KeyboardAction = KeyboardAction = {}));
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoia2V5Ym9hcmQuanMiLCJzb3VyY2VSb290IjoiIiwic291cmNlcyI6WyIuLi8uLi9zcmMvdHlwZXMva2V5Ym9hcmQudHMiXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6IjtBQUFBLDREQUE0RDs7O0FBSTVELElBQVksV0FTWDtBQVRELFdBQVksV0FBVztJQUNuQiw4QkFBZSxDQUFBO0lBQ2YsZ0NBQWlCLENBQUE7SUFDakIsd0NBQXlCLENBQUE7SUFDekIsa0NBQW1CLENBQUE7SUFDbkIsc0NBQXVCLENBQUE7SUFDdkIsc0NBQXVCLENBQUE7SUFDdkIsd0NBQXlCLENBQUE7SUFDekIsMEJBQVcsQ0FBQTtBQUNmLENBQUMsRUFUVyxXQUFXLDJCQUFYLFdBQVcsUUFTdEI7QUFTRCxJQUFZLGNBSVg7QUFKRCxXQUFZLGNBQWM7SUFDdEIsdUNBQXFCLENBQUE7SUFDckIsbUNBQWlCLENBQUE7SUFDakIsMkNBQXlCLENBQUE7QUFDN0IsQ0FBQyxFQUpXLGNBQWMsOEJBQWQsY0FBYyxRQUl6QiJ9